import React from "react";
import {
    Card,
    Table,
} from "antd";
import moment from "moment";

import {crmApi} from "../../../../../api";

const {
    reqOperationLogList
} = crmApi;

export default class ContractLogs extends React.Component {
    state = {
        data: [],
        pagination: {
            showTotal: total => `总数${total}条`,
        },
        loading: false
    };
    columns = [
        {
            title: '操作人',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: '操作类型',
            dataIndex: 'operation_type',
            key: 'operation_type'
        },
        {
            title: '操作对象',
            dataIndex: 'operation_object',
            key: 'operation_object',
        },
        {
            title: '操作时间',
            dataIndex: 'operation_at',
            key: 'operation_at',
            render:(text)=>moment(text).format('YYYY/MM/DD')
        },
    ];

    handleTableChange = (pagination) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({
            pagination: pager
        });
        let params = {
            page: pagination.current,
        };
        this.getList(params);
    }
    
    getList = async (params={}) => {
        this.setState({loading:true});
        params = {...params, operation_object_model: 'Contract'};
        const response = await reqOperationLogList(params)
        if(response && response.data){
            const pagination = {...this.state.pagination};
            pagination.total = response.data.msg.page.total;
            pagination.pageSize = response.data.msg.page.node;
            pagination.current = response.data.msg.page.current;
            let data=[]
            response.data.msg.data.map((item)=>{
                let obj={
                    key: item._id,
                    username: item.operator.dd_info.name,
                    operation_type: item.operation_type,
                    operation_object:item.operation_object,
                    operation_at:item.operation_at,
                }
                data.push(obj)
            })
            this.setState({
                data:data,
                pagination:pagination,
                loading:false,
            })
        }
    } 
    componentDidMount(){
        this.getList()
    }

    render(){
        return (
            <Card
                title="我的申请列表"
                bordered={false}
                style={{marginBottom:24}}
            >
                <Table
                    className="small-table-style"
                    columns={this.columns}
                    dataSource={this.state.data}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                    scroll={{ x: 'max-content' }} // 加上这条  横向滚动  支持此属性的浏览器内容就不会换行了
                    size={'small'}
                />
            </Card>
        );
    }
}